/* ----------------------------

Front End Custom Scripts

---------------------------- */

jQuery(document).ready(function($) {
		
	// Homepage Filtering
	//----------------------------------------------
	
	// Process category filter
	if ($('#filter-category')[0]) {
		
		$('#filter-category').on('select2:select', function(e) {
			
			$('.recent-news--results').css('opacity', 0.3);
			$('.recent-news--results').children().bind('click', function() { return false; });
			
			$('#filter-department').val(null).trigger('change');
			$('#filter-department option:selected').prop('selected', false);
			
			var cat_term_id = e.params.data.id;
			var cat_term_name = e.params.data.text;
			
			console.log('term id: ' + cat_term_id);
			console.log('term name: ' + cat_term_name);
			
			$.ajax({
				url: news_vars.ajax_url,
				format: 'json',
				type: 'GET',
				data: {
					action: 'home_article_filter',
					taxonomy: 'category',
					term_id: cat_term_id
				},
				success: function(response) {
					
					var obj = JSON.parse(response);
					console.log(obj);
					var label;
					
					if (obj.status == 'error') {
						label = 'Reset Stories';
					} else {
						if (obj.count == 0) {
							label = 'Reset Stories';
						} else {
							label = 'See All ' + cat_term_name + ' Stories';
						}
					}
					
					$('.recent-news--results').html(obj.html);
					$('#more-stories').text(label).attr('href', obj.more_url);
					
				},
				error: function(error) {
					
					//console.log('error');
					
				},
				complete: function(response) {
					
					$('.recent-news--results').css('opacity', 1);
					$('.recent-news--results').children().bind('click', function() { return true; });
					$('.recent-news--footer .footer--more-news').hide();
					
				}
			});
			
			
			
		});
		
	}
	
	// Process department filter
	if ($('#filter-department')[0]) {
		
		$('#filter-department').on('select2:select', function(e) {
			
			$('.recent-news--results').css('opacity', 0.3);
			$('.recent-news--results').children().bind('click', function() { return false; });
			
			$('#filter-category').val(null).trigger('change');
			$('#filter-category option:selected').prop('selected', false);
			
			var dept_term_id = e.params.data.id;
			var dept_term_name = e.params.data.text;
			
			$.ajax({
				url: news_vars.ajax_url,
				format: 'json',
				type: 'GET',
				data: {
					action: 'home_article_filter',
					taxonomy: 'elon_departments_cat',
					term_id: dept_term_id
				},
				success: function(response) {
					
					var obj = JSON.parse(response);
					console.log(obj);
					
					if (obj.status == 'error') {
						label = 'Reset Stories';
					} else {
						if (obj.count == 0) {
							label = 'Reset Stories';
						} else {
							label = 'See All ' + dept_term_name + ' Stories';
						}
					}
					
					$('.recent-news--results').html(obj.html);
					$('#more-stories').text(label).attr('href', obj.more_url);
					
				},
				error: function(error) {
					
					//console.log('error');
					
				},
				complete: function(response) {
					
					$('.recent-news--results').css('opacity', 1);
					$('.recent-news--results').children().bind('click', function() { return true; });
					$('.recent-news--footer .footer--more-news').hide();
					
				}
			});
			
		});
		
	}
	
	// Process clearing filters
	if ($('#filter-category')[0] && $('#filter-department')[0]) {
		
		$('#filter-category, #filter-department').on('select2:unselect', function(e) {
			
			resetStories();
			
		});
		
	}
	
	
	
	// Process MailChimp Signup
	//----------------------------------------------
	if ($('#mailchimp-signup')[0]) {
		
		$('#mailchimp-signup').submit(function(e) {
			
			e.preventDefault();
			
			var msg, err, is_err = false, subscribe_email;
			
			$('#mailchimp-error').hide();
			$('#mailchimp-message').hide();
			$('#mailchimp-signup').hide();
			$('#mailchimp-loader').show();
			
			subscribe_email = $('#thisWeekSubscribe').val();
			
			if (subscribe_email) {
				
				$.ajax({
					url: news_vars.ajax_url,
					format: 'json',
					type: 'POST',
					data: {
						action: 'thisweek_subscribe',
						email: subscribe_email
					},
					success: function(response) {
						
						$('#mailchimp-loader').hide();
						
						var obj = JSON.parse(response);
						
						if (obj.status == 'subscribed') {
							
							is_err = false;
							msg = news_vars.this_week_success;
						
						} else if (obj.status == 'elon_error') {
							
							is_err = true;
							err = obj.message;
						
						} else if (obj.status >= 400) {
							
							is_err = true;
							
							if (obj.title == 'Member Exists') {
								err = news_vars.this_week_already_subscribed;
							} else {
								err = news_vars.this_week_general_error;
							}
							
							// console.log(obj.title); // For troubleshooting
							
						} else {
							
							is_err = true;
							msg = news_vars.this_week_general_error;
							
						}
						
						//console.log(response);
						
					},
					error: function(error) {
						
						is_err = true;
						err = news_vars.this_week_general_error;
						
						//console.log(error.responseText);
						
					},
					complete: function(response) {
						
						$('#mailchimp-loader').hide();
						$('#mailchimp-signup').show();
						
						if (is_err) {
							
							$('#mailchimp-message').hide();
							$('#mailchimp-error-text').html(err);
							$('#mailchimp-error').show();
							
						} else {
							
							$('#mailchimp-error').hide();
							$('#mailchimp-message-text').html(msg);
							$('#mailchimp-message').show();
							
						}
						
					}
					
				});
				
			} else {
				
				$('#mailchimp-message').hide();
				$('#mailchimp-error').text(news_vars.this_week_invalid_email).show();
				$('#mailchimp-signup').show();
				
			}
			
		});
		
	}
	
	/**
	 * Search Sidebar Date Picker
	 */
	$('#search-date-after, #search-date-before').datepicker({
		language: 'en',
		autoClose: true,
		clearButton: true,
		onSelect: function(formattedDate, date, inst) {
			$(this).val(formattedDate);
			$(inst.el).trigger('change'); // This plugin doesn't have an onChange event, so we're simulating one.
		}
	});
	
	$('#search-date-after, #search-date-before').change(function(e) {
		isDateRangeValid();
	});
	
	$('#search-date-after, #search-date-before').keyup(function(e) {
		isDateRangeValid();
	});
	/*
	$('#submit-search-form').click(function(e) {
		
		$('.page-content--main').css('opacity', 0.3);
		$('.page-content--main').children().bind('click', function() { return false; });
		$('#submit-search-form').bind('click', function() { return false; });
		$('#submit-search-form').css({'cursor': 'not-allowed', 'opacity': 0.3});
		
	});
	*/
});

/**
* Search date picker validation 
*/
function isDateRangeValid() {
	
	// Get the datepicker data
	var beforeDate = $('#search-date-before').data('datepicker');
	var afterDate = $('#search-date-after').data('datepicker');
		
		
	// We only need to validate if both before and after dates are set
	if ((afterDate.selectedDates[0] !== undefined && beforeDate.selectedDates[0] !== undefined)) {	

		// Convert the values to Date values
		afterDate = new Date(afterDate.selectedDates[0]);
		beforeDate = new Date(beforeDate.selectedDates[0]);
		
		
		// Compare the dates. If the before date is before the after date then we are going to display an error message
		// and disaqble the submit button so an erronious search cannot be submitted. 
		if (afterDate.getTime() > beforeDate.getTime()) {
			
			$('#search-date-before, #search-date-after').addClass('is-invalid');
			$('#search-validation-message').css('display', 'block');
			$('.search-form--submit').attr('disabled', true);
			
		} else {
			
			$('#search-date-before, #search-date-after').removeClass('is-invalid');
			$('#search-validation-message').css('display', 'none');
			$('.search-form--submit').attr('disabled', false);
			
		}	
	} else {
		
		$('#search-date-before, #search-date-after').removeClass('is-invalid');
		$('#search-validation-message').css('display', 'none');
		$('.search-form--submit').attr('disabled', false);
		
	}
}


/**
 * Reset stories on homepage.
 */
function resetStories() {
	
	$('#filter-category').val(null).trigger('change');
	$('#filter-category option:selected').prop('selected', false);
	
	$('#filter-department').val(null).trigger('change');
	$('#filter-department option:selected').prop('selected', false);
	
	$('.recent-news--results').css('opacity', 0.3);
	$('.recent-news--results').children().bind('click', function() { return false; });
	
	//var cat_val = $('#filter-category option:selected').val();
	//var dept_val = $('#filter-department option:selected').val();
	
	$.ajax({
		url: news_vars.ajax_url,
		format: 'json',
		type: 'GET',
		data: {
			action: 'home_article_reset'
		},
		success: function(response) {
			
			var obj = JSON.parse(response);
			// console.log(obj);
			
			$('.recent-news--results').html(obj.html);
			$('#more-stories').text('See All Stories').attr('href', news_vars.home_filter_url);
			
		},
		error: function(error) {
			
			//console.log('error');
			
		},
		complete: function(response) {
			
			$('.recent-news--results').css('opacity', 1);
			$('.recent-news--results').children().bind('click', function() { return true; });
			$('.recent-news--footer .footer--more-news').show();
			
		}
	});
	
}


// sidebar widgets location depending on screen size
jQuery(function($) {

	var mobileNavBreakpoint = 1080,
			$widgetContainerDesktop = $('#sidebarWidgetsDesktop'),
			$widgetContainerMobile = $('#sidebarWidgetsMobile');
	
	function moveSidebarWidgets() {
		var windowWidth = $(window).width();
		
		if (windowWidth >= mobileNavBreakpoint) {
			$widgetContainerMobile.contents().appendTo($widgetContainerDesktop);
		} else {
			$widgetContainerDesktop.contents().appendTo($widgetContainerMobile);
		}
	}

	// Window listeners	
	$(window).resize(function(){
		moveSidebarWidgets();
	});
	
	moveSidebarWidgets();

});